import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IMicroscope } from '../../interface/microscope.interface';
import { MicroscopeService } from '../../service/microscope.service';
import { IError } from '@suvo-bi-core';
import { EditComponent } from 'apps/mba-cpr-survey-portal/src/app/shared/components/edit/edit.component';

@Component({
  selector: 'app-microscope-edit-screen',
  templateUrl: './microscope-edit-screen.component.html',
  styleUrls: ['./microscope-edit-screen.component.scss'],
})
export class MicroscopeEditScreenComponent implements OnInit, OnDestroy {
  @ViewChild('editComponent') editComponent: EditComponent;
  private readonly unsubscribe$ = new Subject<void>();
  readonly formGroup = new FormGroup({
    oldMicroscopeId: new FormControl<number>(null),
    label: new FormControl('', { nonNullable: true }),
    description: new FormControl('', { nonNullable: true }),
    inUse: new FormControl(false, { nonNullable: true }),
  });
  microscope: IMicroscope;

  serverErrors: Array<IError>;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly microscopes: MicroscopeService,
  ) {}

  ngOnInit() {
    this.route.data
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ data }: { data?: IMicroscope }) => {
        if ((this.microscope = data)) {
          this.formGroup.setValue({
            oldMicroscopeId: data.oldMicroscopeId,
            label: data.label,
            description: data.description,
            inUse: !!data.inUse,
          });
        }
      });

    //Important, the edit component forces the whole form to be enabled, so need to set this back to disabled
    this.formGroup.statusChanges.subscribe(() => {
      if (!!this.microscope?._id && !this.formGroup.controls['oldMicroscopeId'].disabled) {
        this.formGroup.controls['oldMicroscopeId'].disable();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async onSave($event: IMicroscope) {
    this.serverErrors = null;
    try {
      if (this.microscope?._id) {
        await this.microscopes.patchOne('', this.microscope._id, $event);
        this.editComponent.markAsUpdated();
      } else {
        const { _id } = await this.microscopes.postOne('', $event);
        await this.router.navigate(['..', _id], { relativeTo: this.route });
      }
    } catch (e) {
      this.serverErrors = [e.error];
      this.editComponent.enable();
    }
  }
}
